(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/payable-status.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/payable-status.js');
"use strict";


const payableStatus = {
  VALID: 'valid',
  INCOMPLETE: 'incomplete',
  INVALID_ROW_PRICE: 'invalidRowPrice',
  MIN_AMOUNT: 'minAmount',
  MAX_AMOUNT: 'maxAmount',
  MAX_SELECTIONS: 'maxSelections'
};
svs.racing.gameEngine.payableStatus = payableStatus;

 })(window);